import { collectGuide } from "@/mocks/homeData";

export default function CollectSection() {
  return (
    <section id="collect" className="w-full px-4 md:px-8 py-12 md:py-16 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-3 mb-8">
          <div>
            <span className="text-xs font-medium tracking-wide text-primary-600">收藏指南</span>
            <h2 className="mt-2 font-heading font-bold text-xl md:text-3xl text-foreground-950">
              下次不再到处找入口
            </h2>
            <p className="mt-2 text-sm text-foreground-600 max-w-2xl">
              把入口固定下来，比每次重新搜索更快也更安全。按下面四点做一次，就一劳永逸。
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {collectGuide.map((item, index) => (
            <div
              key={item.id}
              className="bg-background-100 rounded-lg border border-background-200 p-5 flex flex-col gap-3 h-full"
            >
              <span className="w-8 h-8 rounded-md bg-primary-100 text-primary-700 flex items-center justify-center font-heading font-bold text-sm">
                {index + 1}
              </span>
              <h4 className="font-medium text-sm text-foreground-950 leading-snug">{item.title}</h4>
              <p className="text-xs leading-relaxed text-foreground-600">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}